export interface ClareUserPermission {
    id: number;
    name: string;
}

export interface UserRole {
    name: ROLE_NAMES;
    id: number;
    permissions: ClareUserPermission[];
}

/**
 * Role ids. Don't rely on these, they may be different in production.
 *
 * @deprecated
 */
export enum USER_ROLES {
    CUSTOMER = 1,
    SECURITY_ADMIN = 2,
    BILLING_ADMIN = 3,
    COMPANY_ADMIN = 4,
    INSTALLER = 5,
    CLARE_ADMIN = 34,
    PROPERTY_MANAGER_COORDINATOR = 37,
    PROPERTY_MANAGER_ADMIN = 42,
}

export enum ROLE_NAMES {
    CUSTOMER = "Customer",
    SECURITY_ADMIN = "Security Admin",
    BILLING_ADMIN = "Billing Admin",
    COMPANY_ADMIN = "Company Admin",
    INSTALLER = "Installer",
    CLARE_ADMIN = "Clare Admin",
    PROPERTY_MANAGER_COORDINATOR = "Property Manager Coordinator",
    PROPERTY_MANAGER_ADMIN = "Property Manager Admin",
}

/**
 * Whether a role has permission to edit other roles
 */
export const ROLE_HIERARCHY: Partial<Record<ROLE_NAMES, Readonly<ROLE_NAMES[]>>> = {
    [ROLE_NAMES.PROPERTY_MANAGER_ADMIN]: [ROLE_NAMES.PROPERTY_MANAGER_ADMIN, ROLE_NAMES.PROPERTY_MANAGER_COORDINATOR],
    [ROLE_NAMES.COMPANY_ADMIN]: [
        ROLE_NAMES.SECURITY_ADMIN,
        ROLE_NAMES.BILLING_ADMIN,
        ROLE_NAMES.SECURITY_ADMIN,
        ROLE_NAMES.COMPANY_ADMIN,
        ROLE_NAMES.INSTALLER,
        ROLE_NAMES.PROPERTY_MANAGER_COORDINATOR,
        ROLE_NAMES.PROPERTY_MANAGER_ADMIN,
    ],
} as const;
